<div class="text-center title">Check In / Check Out Events</div>

<div class="text-center text-muted">Note: shows events for all reservations</div>

<div class="flx-container">

  <div class="flx-item flx-fill text-right">
    <button class="btn btn-primary btn-round hvr-push" (click)="onRefreshDataClick()">Refresh</button>
  </div>

  <div class="flx-break"></div>

  <div class="flx-item flx-fill">
    <check-in-event-grid [results]="results" [retrieving]="retrieving" (invalidated)= "onGridDataInvalidated($event)"> </check-in-event-grid>

    @if (retrieving) {
      <spinner messageRelativePosition="bottom"> </spinner>
    }
  </div>

  <div class="flx-break"></div>
</div>
